import React from "react";
import { component_tool, utils_tool } from "@/tool";
import columns from "./columns";
import uniqBy from "lodash/uniqBy";
import { WizTableForm } from "@/containers/common";

const { WizComponent, WizDataTable, WizButton, WizModal, WizTabs } = component_tool;

const program = WizTableForm.Config.program(this, {apiParams: { }})
const live = WizTableForm.Config.live(this, {apiParams: { state: 4}})

const { getPageData, isEqual } = utils_tool

class FormTable extends WizComponent {
  componentName = "FormTable";

  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      records: props.value || [],
      selectedRows: [],
      activeKey: 1,
    };

    this.config = [
      { key: 1, title: '直播', ...live },
      { key: 2, title: '课程', ...program },
    ]
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.value !== nextProps.value) {
      this.setState({
        records: nextProps.value
      });
    }
  }

  propsAndStateOnChange = {
    records: this._records.bind(this)
  }

  _records(nextProps, nextState) {
    const { onChange } = this.props
    const { records } = nextState
    const _records = Array.isArray(records) && records.length === 0 ? null : records
    onChange && onChange(_records)
    return true;
  }

  // 添加
  handleAdd = () => {
    this.setState({ visible: true, activeKey: 1 })
  }

  // 删除
  handleDelete = (index) => {
    const { records } = this.state
    const _records = JSON.parse(JSON.stringify(records))

    _records.splice(index, 1)

    this.setState({ records: _records })
  }

  // 弹出条件数据表格选择行
  onSelectedRows = selectedRows => {
    this.setState({ selectedRows })
  }

  // 弹出条件数据表格tab切换
  handleTabOnChange = (activeKey) => {
    this.setState({ activeKey })
  }

  formatRows = selectedRows => {
    const { activeKey } = this.state
    const entityType = this.config[activeKey - 1].key

    const getState = state => {
      let entityStateName;
      if(entityType === 1) {
        const dict = ['草稿','发布', '关闭']
        entityStateName = dict[state]
      } else if(entityType === 2) {
        const dict = ['草稿','预告','直播','结束']
        entityStateName = dict[state-1]
      }
      return entityStateName
    }

    return selectedRows.map(val => ({
      entityId: val.id,
      entityType,
      entityName: val.name,
      entityStartTime: val.startDate,
      entityEndTime: val.endDate,
      entityStateName: getState(activeKey === 1? val.state: val.status),
    }))
  }

  // 弹出条件数据表格确认按钮
  onOk = () => {
    const { selectedRows, records } = this.state
    if(!selectedRows.length) {
      wizNotice.warn('请选择一行数据')
      return
    }

    const _filter = uniqBy([ ...records, ...this.formatRows(selectedRows) ], 'entityId')

    this.setState({ visible: false, records: _filter })
  }

  // 弹出条件数据表格取消按钮
  onCancel = () => {
    this.setState({ visible: false, activeKey: 1 })
  }

  render() {
    const { visible, records } = this.state
    const { linksValues, value } = this.props

    const dataItems = getPageData({ records })

    const dataTableProps = {
      style: { marginBottom: 15 },
      columns: columns.call(this, value),
      dataItems,
      rowKey: 'entityId',
      isScroll: true,
    }

    const modalProps = {
      visible,
      width: 950,
      onOk: this.onOk,
      onCancel: this.onCancel,
      style: { top: 30 }
    }

    return (
      <React.Fragment>
        <WizDataTable {...dataTableProps} />

        { visible? <WizModal { ...modalProps }>
          <WizTabs animated={false} onChange={this.handleTabOnChange}>
            { this.config.map((val, index) =>
              <WizTabs.TabPane tab={val.title} key={val.key}>
                <WizTableForm key={val.key} showModal={false} selectType={linksValues === 1 ? 'radio': 'checkbox'} { ...val } onSelectedRows={ this.onSelectedRows } />
              </WizTabs.TabPane>
            )}
          </WizTabs>
        </WizModal> : null }

        { linksValues === 1 && records.length >= 1 ? null : <WizButton type="primary" icon="plus" onClick={() => this.handleAdd()}>添加</WizButton> }

      </React.Fragment>
    )
  }
}

export default FormTable
